import { type CaProvince } from '../types';

export const CA_PROVINCES: CaProvince[] = [
    { abbr: 'AB', name: 'Alberta' },
    { abbr: 'BC', name: 'British Columbia' },
    { abbr: 'NL', name: 'Labrador' },
    { abbr: 'MB', name: 'Manitoba' },
    { abbr: 'NL', name: 'Newfoundland' },
    { abbr: 'NB', name: 'New Brunswick' },
    { abbr: 'NT', name: 'Northwest Territories' },
    { abbr: 'NS', name: 'Nova Scotia' },
    { abbr: 'NU', name: 'Nunavut' },
    { abbr: 'ON', name: 'Ontario' },
    { abbr: 'PE', name: 'Prince Edward Island' },
    { abbr: 'QC', name: 'Quebec' },
    { abbr: 'SK', name: 'Saskatchewan' },
    { abbr: 'YT', name: 'Yukon Territory' },
];
